import { useEffect } from 'react';

export function useEffectAsync(effect: () => any, inputs: any[]) {
  useEffect(() => {
    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, inputs);
}
